import {CommonsService} from '../../commons-service'; 
import {Injectable} from "@angular/core";
import {TipoCobranca} from './tipocobranca'; 

@Injectable({ providedIn: 'root' }) 
export class TipoCobrancaService extends CommonsService<TipoCobranca> { 

     getPathModule(): string { 
         return 'tipocobranca'; 
     } 
} 
